export default {
  labels: {
    selectOne: 'एक विकल्प चुनें',
    selectAll: 'सभी लागू विकल्प चुनें',
    typeResponse: 'अपना उत्तर नीचे दिए गए टेक्स्ट बॉक्स में टाइप करें।',
    recordResponse: 'प्रश्न का उत्तर देने के लिए एक रिकॉर्डिंग बनाएं।',
    enterNumeric: 'नीचे दिए गए फ़ील्ड में एक संख्यात्मक उत्तर दर्ज करें।',
    rateResponseScale: 'प्रदान किए गए पैमाने पर अपने उत्तर को रेट करें।',
    sliderMinimum: 'न्यूनतम मान: {value}',
    sliderMaximum: 'अधिकतम मान: {value}',
    selectOneOptionRow: 'प्रत्येक पंक्ति में एक विकल्प चुनें।',
    selectAllOptionsRow: 'प्रत्येक पंक्ति के लिए सभी लागू विकल्प चुनें।',
    dragAndDropResponse: 'प्राथमिकता के अनुसार उन्हें रैंक करने के लिए विकल्पों को खींचें और छोड़ें।',
    rankOrderDesktopInstruction: 'आइटम को क्रमबद्ध करने के लिए खींचें और छोड़ें, या + बटन का उपयोग करके आइटम जोड़ें। क्रम बदलने के लिए तीर बटन या हटाने के लिए डिलीट बटन का उपयोग करें।',
    alert: "चेतावनी",
    error: 'कृपया {min} और {max} के बीच एक संख्या दर्ज करें।',
    cameras: 'कैमरे',
    microphones: 'माइक्रोफ़ोन',
    recording: 'रिकॉर्डिंग',
    noDevicesFound: 'कोई डिवाइस नहीं मिला',
    camera: 'कैमरा',
    microphone: 'माइक्रोफ़ोन',
    stopRecording: 'रिकॉर्डिंग रोकें',
    startRecording: 'रिकॉर्डिंग शुरू करें',
    disableCamera: 'कैमरा अक्षम करें',
    enableCamera: 'कैमरा सक्षम करें',
    disableMicrophone: 'माइक्रोफ़ोन अक्षम करें',
    enableMicrophone: 'माइक्रोफ़ोन सक्षम करें',
    settings: 'सेटिंग्स',
    recordingProgress: 'रिकॉर्डिंग प्रगति',
    playbackProgress: 'प्लेबैक प्रगति',
    play: 'चलाएं',
    pause: 'रोकें',
    stop: 'रोकें',
    record: 'रिकॉर्ड करें',
    recordAgain: 'फिर से रिकॉर्ड करें',
    retry: 'फिर से प्रयास करें',
    done: 'हो गया',
    minRecordTime: 'कृपया {min} सेकंड के लिए उत्तर रिकॉर्ड करें।',
    enlargeImage: 'छवि बड़ी करें',
    enlargedImage: 'बड़ी की गई छवि',
    close: 'बंद करें',
    zoomIn: 'ज़ूम इन करें',
    zoomOut: 'ज़ूम आउट करें',
    resetZoom: 'ज़ूम रीसेट करें',
    zoomLevel: 'ज़ूम {percentage}%',
    imagePosition: '{total} में से {current}',
    previousImage: 'पिछली छवि',
    nextImage: 'अगली छवि',
    imageLoading: 'छवि लोड हो रही है',
    imageLoadFailed: 'छवि लोड नहीं हो सकी',
  },
  noSelection: "कोई चयन नहीं",
  actions: {
    increase: 'बढ़ाएं',
    decrease: 'कम करें'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'सर्वेक्षण पूर्वावलोकन समाप्त',
      titleCompleted: 'सर्वेक्षण पूर्वावलोकन पूर्ण',
      previewModeWarning: 'यह पृष्ठ केवल पूर्वावलोकन मोड में दिखाई देता है और वास्तविक उत्तरदाताओं को नहीं दिखाया जाएगा।',
      reachedEndPoint: 'यह सर्वेक्षण एक समाप्ति बिंदु पर पहुंच गया है।',
      reachedEndPointCompleted: 'यह पूर्वावलोकन एक समाप्ति बिंदु पर पहुंच गया है।',
      returnToModify: 'अपने उत्तर संशोधित करने और एक अलग सर्वेक्षण पथ का परीक्षण करने के लिए पिछले प्रश्न पर लौटें।',
      logic: 'तर्क'
    }
  }
}
